import { DATA_COLLECTION_CONFIGS } from "pages/dataCollection/_shared/config";
import { DataCollectionPage } from "pages/dataCollection/_shared/DataCollectionPage";

function VotingBody() {
  return <DataCollectionPage config={DATA_COLLECTION_CONFIGS.votingBody} />;
}

export default VotingBody;
